import React from "react";
import styled from "styled-components";

import { IconPrintLine } from "../icons";

const OverlayText = styled.div`
  text-align: center;
  display: flex;
  gap: 1rem;

  button {
    margin: auto;
    margin-top: 1rem;
    text-align: center;
  }
`;
const OverlayTextIcon = styled.div`
  svg {
    width: 16px;
  }
`;
const OverlayTextLabel = styled.div``;
const OverlayIcon = styled.div`
  svg {
    width: 5rem;
    fill: #888;
  }
`;

const PDFOverlayText: React.FC<
  React.PropsWithChildren<{
    icon?: React.ReactNode;
  }>
> = ({ icon, children }) => (
  <>
    {icon && <OverlayTextIcon>{icon}</OverlayTextIcon>}
    <OverlayTextLabel>{children}</OverlayTextLabel>
  </>
);

export const PDFOverlay: React.FC<
  React.PropsWithChildren<{ icon?: React.ReactNode }>
> & {
  Text: typeof PDFOverlayText;
} = ({ icon, children }) => (
  <>
    <OverlayIcon>{icon || <IconPrintLine />}</OverlayIcon>
    <OverlayText>{children}</OverlayText>
  </>
);

PDFOverlay.Text = PDFOverlayText;
